<template>
  <div class="way">
    <h1 class="title">Xport 之道</h1>
    <div class="box">
      <div class="children-l">
        <div class="background">
          <img
            src="@/assets/careers/ricardo-gomez-angel-9AdeEdYB2yk-unsplash.jpg"
            v-if="active === 0"
          />
          <img
            src="@/assets/careers/martin-adams-6Gsq3DxFdCQ-unsplash.jpg"
            v-if="active === 1"
          />
          <img
            src="@/assets/careers/li-zhang-K-DwbsTXliY-unsplash.jpg"
            v-if="active === 2"
          />
          <img
            src="@/assets/careers/ramon-salinero-vEE00Hx5d0Q-unsplash.jpg"
            v-if="active === 3"
          />
          <img
            src="@/assets/careers/andrew-ridley-jR4Zf-riEjI-unsplash.jpg"
            v-if="active === 4"
          />
          <div
            :class="['tab', item.check ? 'check-tab' : '']"
            v-for="item in options"
            :key="item.value"
            v-html="item.title"
            @click="chnageTab(item)"
          ></div>
        </div>
      </div>
      <div class="children-r">
        <van-swipe
          class="legend"
          ref="dragScroll"
          touchable
          stop-propagation
          indicator-color="transparent"
          :loop="false"
          @change="chnagSwp"
        >
          <van-swipe-item>
            <p class="item">
              我们在各个层面都承担责任，无论是个人还是团队，都对我们的项目和行动负责。我们致力于始终如一地提供卓越的成果，信奉个人责任感的文化。
            </p>
          </van-swipe-item>
          <van-swipe-item>
            <p class="item">
              协作不仅是我们文化不可或缺的一部分;这是我们的核心。我们的团队内部和跨部门密切合作是建立世界领先的全球电子商务平台并推动客户持续成功的关键。
            </p>
          </van-swipe-item>
          <van-swipe-item>
            <p class="item">
              无论是通过自我驱动学习还是协作知识共享，我们都营造了一个持续专业和个人发展的环境，使自己有能力提高我们的技能并推动我们团队成员的成长。
            </p>
          </van-swipe-item>
          <van-swipe-item>
            <p class="item">
              通过将挑战视为机遇，我们超越了解决问题的局限，相信没有障碍是太大的，也没有问题是无法解决的。这种心态推动了一种不断进步、创新和开箱即用思维的文化，推动我们在每一个转折点都超越期望。
            </p>
          </van-swipe-item>
          <van-swipe-item>
            <p class="item">
              我们相信每个人都应该有平等的机会来追求成功、茁壮成长和追求卓越。我们团队内部的不同观点和经验加强了我们对机会均等的承诺，推动我们做到最好。
            </p>
          </van-swipe-item>
        </van-swipe>
        <!-- <drag-scroll
          ref="dragScroll"
          class="legend"
        >
          <p class="item">
            我们在各个层面都承担责任，无论是个人还是团队，都对我们的项目和行动负责。我们致力于始终如一地提供卓越的成果，信奉个人责任感的文化。
          </p>
          <p class="item">
            协作不仅是我们文化不可或缺的一部分;这是我们的核心。我们的团队内部和跨部门密切合作是建立世界领先的全球电子商务平台并推动客户持续成功的关键。
          </p>
          <p class="item">
            无论是通过自我驱动学习还是协作知识共享，我们都营造了一个持续专业和个人发展的环境，使自己有能力提高我们的技能并推动我们团队成员的成长。
          </p>
          <p class="item">
            通过将挑战视为机遇，我们超越了解决问题的局限，相信没有障碍是太大的，也没有问题是无法解决的。这种心态推动了一种不断进步、创新和开箱即用思维的文化，推动我们在每一个转折点都超越期望。
          </p>
          <p class="item">
            我们相信每个人都应该有平等的机会来追求成功、茁壮成长和追求卓越。我们团队内部的不同观点和经验加强了我们对机会均等的承诺，推动我们做到最好。
          </p>
        </drag-scroll> -->
        <!-- <div class="legend">
          <div
            class="list"
            id="list"
          >

          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Way',
  components: {},
  props: {},
  data() {
    return {
      active: 0,
      options: [
        {
          url: 'ricardo-gomez-angel-9AdeEdYB2yk-unsplash.ipg',
          value: 0,
          title: '责任',
          check: true
        },
        {
          url: 'martin-adams-6Gsq3DxFdCQ-unsplash.ipg',
          value: 1,
          title: '团队合作'
        },
        {
          url: 'li-zhang-K-DwbsTXliY-unsplash.ipg',
          value: 2,
          title: '培养<br /> 成长'
        },
        {
          url: 'ramon-salinero-vEE00Hx5d0Q-unsplash.ipg',
          value: 3,
          title: '我能做的<br /> 心态'
        },
        {
          url: 'andrew-ridley-jR4Zf-riEjI-unsplash.ipg',
          value: 4,
          title: '机会<br /> 平等'
        }
      ]
    }
  },
  computed: {
    src() {
      return this.options.find(item => item.value === this.active).url
    }
  },
  mounted() {},
  methods: {
    chnageTab(e) {
      this.options.forEach(item => {
        item.check = e.value === item.value
      })
      this.active = e.value
      this.$refs.dragScroll.swipeTo(e.value)

      // this.$refs.dragScroll.offsetX = (e.value - 1) * 460
    },
    chnagSwp(e) {
      this.options.forEach(item => {
        item.check = item.value === e
      })
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.way {
  font-family: 'Poppins', Sans-serif;
  margin: 0 auto;
  padding-bottom: 100px;
  width: 1140px;
  .title {
    margin: 54px 0 100px;
    color: #2a2c2f;
    font-size: 48px;
    font-weight: 600;
    text-align: center;
  }
  .box {
    display: flex;

    .children-l {
      width: 50%;

      .background {
        width: 450px;
        height: 450px;
        position: relative;
        img {
          object-fit: cover;
          border-radius: 50%;
          width: 100%;
          height: 100%;
        }
        .tab {
          z-index: 20;
          position: absolute;
          display: flex;
          font-size: 20px;
          font-weight: 600;
          text-transform: uppercase;
          line-height: 1.1em;
          align-items: center;
          text-align: center;
          cursor: pointer;
          transition: 0.5s;
          height: 70px;
          border-radius: 40px;
          box-shadow: 0px 0px 15px #00000015;
          padding: 0 30px;
          background-color: #fff;
        }
        .tab:nth-child(2) {
          top: 50%;
          transform: translate(50%, -100%);
          right: 0;
        }
        .tab:nth-child(3) {
          top: 100%;
          transform: translate(0, -100%);
          right: 0;
        }
        .tab:nth-child(4) {
          top: 100%;
          transform: translate(0, -100%);
          left: 0;
        }
        .tab:nth-child(5) {
          top: 50%;
          transform: translate(-50%, -100%);
          left: 0;
        }
        .tab:nth-child(6) {
          top: 0;
          transform: translate(-50%, -50%);
          left: 50%;
        }
        .tab:hover {
          background: #ff6000;
          color: #fff;
        }
        .check-tab {
          background: #ff6000;
          color: #fff;
        }
      }
    }
    .children-r {
      width: 50%;
      .legend {
        margin: 150px auto;
        width: 450px;
        overflow: hidden;
        //   .list {
        //     transition: all 0.5s;
        //     width: auto;
        //     display: flex;
        ::v-deep .van-swipe-item {
          cursor: pointer;
          width: 450px !important;
          padding: 30px;
          margin-top: 10px;
          p {
            color: #000000;
            font-family: 'Arimo', sans-serif;
            font-size: 16px;
            line-height: 1.4em;
          }
        }
        // }
      }
    }
  }
}
</style>
